import { createFileRoute } from '@tanstack/react-router';
import { NoteEditor } from '@/components/Modules/Notes';

export const Route = createFileRoute('/notes/$id')({
  component: NoteEditor,
});
